import React from "react";
import classNames from "classnames";

const Container = ({ children, className }) => {
  return (
    <div className={classNames("max-w-[1320px] mx-auto p-4", className)}>
      {children}
    </div>
  );
};

export default Container;
